import React from "react";

/**
 * Controlled input group for one person's birth details.
 * value shape: { name, gender, dob, tob, place }
 */
export default function BirthProfileFields({ label, value, onChange }) {
  const update = (field, val) => onChange({ ...value, [field]: val });

  
  return (
    <fieldset style={styles.fieldset}>
      {label && <legend style={styles.legend}>{label}</legend>}

      <div style={styles.field}>
        <label style={styles.label}>Full name</label>
        <input
          className="km-input" style={styles.input}
          value={value.name || ""}
          onChange={(e) => update("name", e.target.value)}
          placeholder="e.g. Sandeep Kumar"
        />
      </div>

      <div style={styles.field}>
        <label style={styles.label}>Gender</label>
        <select
          className="km-input" style={styles.input}
          value={value.gender || "male"}
          onChange={(e) => update("gender", e.target.value)}
        >
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
      </div>

      <div style={styles.row2}>
        <div style={{ ...styles.field, flex: 1 }}>
          <label style={styles.label}>Date of birth</label>
          <input
            className="km-input" style={styles.input}
            type="date"
            value={value.dob || ""}
            onChange={(e) => update("dob", e.target.value)}
          />
        </div>
        <div style={{ ...styles.field, flex: 1 }}>
          <label style={styles.label}>Time of birth</label>
          <input
            className="km-input" style={styles.input}
            type="time"
            step="1"
            value={value.tob || ""}
            onChange={(e) => update("tob", e.target.value)}
          />
        </div>
      </div>

      <div style={styles.field}>
        <label style={styles.label}>Place of birth</label>
        <input
          className="km-input" style={styles.input}
          value={value.place || ""}
          onChange={(e) => update("place", e.target.value)}
          placeholder="City, State"
        />
      </div>
    </fieldset>
  );
}

const styles = {
  fieldset: {
    border: "1px solid var(--line)", borderRadius: "var(--radius)",
    padding: 16, flex: 1, minWidth: 0, margin: 0,
    background: "var(--card)",
  },
  legend: {
    padding: "0 8px", fontWeight: 700, color: "var(--terracotta-dark)",
    fontFamily: "var(--font-serif)", fontSize: 17,
  },
  field: { marginBottom: 12 },
  row2: { display: "flex", gap: 10 },
  label: {
    display: "block", fontSize: 12, fontWeight: 600, marginBottom: 5,
    color: "var(--ink-soft)", letterSpacing: 0.2,
  },
  input: {
    width: "100%", padding: "10px 12px", borderRadius: "var(--radius-sm)",
    border: "1px solid var(--line)", fontSize: 14, boxSizing: "border-box",
    background: "#fff", color: "var(--ink)", transition: "border-color 0.15s",
  },
};
